import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = {
  class: "modal-title",
  id: "staticBackdropLabel"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = {
  class: "modal-backdrop fade show",
  id: "backdrop"
}

import { reactive, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDorape',
  props: ['visible', 'title', 'id', 'usarFooter', 'usarModal', 'larguraMaxima', 'alturaMaxima'],
  emits: ["modalResult"],
  setup(__props, { emit }) {

const props = __props;



const state = reactive({});

function cancelar() {
    document.querySelector("html")?.classList.remove("overflow-hidden");
    emit("modalResult", "cancel", props.id);
}
function confirmar() {
    document.querySelector("html")?.classList.remove("overflow-hidden");
    emit("modalResult", "ok", props.id);
}

function bloquearScroll() {
    // setInterval(() => {
    // console.log(`${props.visible} - Modal`);
    (props.visible) ?
        document.querySelector("html")?.classList.add("overflow-hidden")
        :
        document.querySelector("html")?.classList.remove("overflow-hidden");
    "";
    // }, 100);
}

onMounted(() => {
    // console.log();
    bloquearScroll();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "modal fade show",
      id: __props.id,
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false",
      tabindex: "-1",
      "aria-labelledby": "staticBackdropLabel",
      "aria-modal": "true",
      style: {"display":"block"}
    }, [
      _createElementVNode("div", {
        class: "modal-dialog modal-dialog-centered",
        style: _normalizeStyle({ 'min-width': __props.larguraMaxima })
      }, [
        _createElementVNode("div", {
          class: "modal-content",
          style: _normalizeStyle({ 'min-height': __props.alturaMaxima })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.title), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelar()))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _renderSlot(_ctx.$slots, "footer"),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: cancelar
            }, "Cancelar"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: confirmar
            }, "Confirmar")
          ], 512), [
            [_vShow, __props.usarFooter]
          ])
        ], 4)
      ], 4)
    ], 8, _hoisted_1), [
      [_vShow, (__props.visible === true && __props.usarModal)]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
      [_vShow, (__props.visible && __props.usarModal)]
    ])
  ], 64))
}
}

})